var ViewController = require("./ViewController"),
    kind           = require("enyo/kind");

module.exports = kind(/** @lends  app.core.MediaPlayerController.prototype */ {

    /**
     * @private
     */
    name: "app.core.MediaPlayerController",

    /**
     * @private
     */
    kind: ViewController,

    /**
     * MediaPlayerController does not clear the app-state before activation,
     * because we may choose to continue with the existing state. For example,
     * when the activation request is the same as the one that's already
     * playing. (aka, playing the same item, in the same playlist)
     *
     * @protected
     */
    resetAppState: function() {
        // No-op
    },

    /**
     * Build an activation fingerprint. Extend or override as needed.
     *
     * @param    {Object}  params  The parameters
     * @returns  {Object}  The fingerprint
     * @protected
     */
    buildActivationFingerprint: function(params) {
        var $authService = this.app.$.authService;

        return {
            params:         params,
            userId:         ($authService.get("user") || {}).id || null,
            userPrivileges: $authService.getUserPrivileges()
        };
    },

    /**
     * @private
     */
    destroy: kind.inherit(function(sup) {
        return function() {
            var $appState = this.app.$.state;

            sup.apply(this, arguments);

            // Remove ourselves as mediaPlayerController if we're still listed
            // as such
            if ($appState.get("mediaPlayerController") === this) {
                $appState.resetMediaPlayerState();
            }
        };
    })

});
